import React, { useContext, useState, useEffect } from 'react';
import { Button, Card, Col, Form, Row } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import ModalSFS from 'components/theme_components/ModalSFS';
import ProductFraisModal from './ProductModals/ProductFeesModal';
import Title from 'components/Title';
import IBasket from 'icons/IBasket';
import IPen from 'icons/IPen';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ProductFeesModal from './ProductModals/ProductFeesModal';

export type ProductFraisProps = {
  form: any;
  feesList: any[];
  setFeesList: (item: any) => void;
  setIsFeesSelected: (value: boolean) => void;
  setSelectedItem: (item: any) => void;
  setModalVisible: (value: boolean) => void;
  modalVisible: boolean;
  setVisible: (value: boolean) => void;
  isInspect: any;
};

const ProductFees = ({
  form,
  feesList,
  setFeesList,
  setIsFeesSelected,
  setSelectedItem,
  setModalVisible,
  setVisible,
  modalVisible,
  isInspect,
}: ProductFraisProps) => {
  const [FraismodalVisible, setFraisModalVisible] = useState(false);
  const [item, setItem] = useState('' as any);

  const deleteCard = (key: string) => {
    setFeesList(feesList.filter((item) => item.key !== key));
  };
  return (
    <Form className="container-stepper mt-4 taux productlist" form={form}>
      <Title
        comcode="infoToCompletefrais"
        level={4}
        className="ut-updateTP-title mb-7 mt-10"
      />

      <Row
        className="mb-4 px-6 text-center"
        gutter={24}
        justify="space-between"
        align="middle"
      >
        <Col span={2}>
          <GetLabel
            label="type"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>
        <Col span={2}>
          <GetLabel
            label="servcategory"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>
        <Col span={3}>
          <GetLabel
            label="frequency"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>
        <Col span={2}>
          <GetLabel
            label="startday"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>
        <Col span={2}>
          <GetLabel
            label="endday"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>
        <Col span={2}>
          <GetLabel
            label="periodicity"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>

        <Col span={2}>
          <GetLabel
            label="firstinvoice"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>
        <Col span={4}>
          <GetLabel
            label="rateamount"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>
        <Col span={2}>
          <GetLabel
            label="invoice"
            className=" font-size-13 font-weight-600 gray-color"
          />
        </Col>
        <Col span={2}></Col>
      </Row>

      {feesList.length === 0 && (
        <Card
          style={{ zIndex: 100 }}
          className="no-border-radius no-border text-center mb-4 textCard"
        >
          <GetLabel
            label="fraisVid"
            className="font-size-13 gray-color text-center "
          />
        </Card>
      )}

      {feesList.map((item) => (
        <Card
          key={item.key}
          style={{ zIndex: 100 }}
          className="activity-card mb-4 text-center"
        >
          <Row gutter={10} justify="space-between" align="middle">
            {item.servcalculationmethod ? (
              <GetLabel label={item.servcalculationmethod} />
            ) : (
              '-'
            )}
            <Col span={isInspect ? 12 : 3}>
              {item.servcategory ? <GetLabel label={item.servcategory} /> : '-'}
            </Col>
            <Col span={isInspect ? 12 : 2}>
              {item.servduration ? <GetLabel label={item.servduration} /> : '-'}
            </Col>
            <Col span={2}>{item.servstartday || '-'}</Col>
            <Col span={2}>{item.servendday || '-'}</Col>
            <Col span={2}>{item.servperiodicity || '-'}</Col>
            <Col span={2}>{item.servbillingday || '-'}</Col>
            <Col span={isInspect ? 12 : 4}>
              {' '}
              {item.servfixedamount ? (
                <>
                  <span className="gray-color">
                    <GetLabel label="amount" />{' '}
                  </span>{' '}
                  {`${
                    item.servfixedamount != null
                      ? item.servfixedamount
                          .toLocaleString('fr-FR', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          })
                          .replace('.', ',') + ' €'
                      : '-'
                  }`}
                </>
              ) : (
                <>
                  <span className="gray-color">
                    <GetLabel label="rate" />
                  </span>{' '}
                  {`${
                    item.feesrate != null
                      ? item.feesrate.toString().replace('.', ',') + ' %'
                      : '-'
                  }`}{' '}
                  <br />
                  <span className="gray-color">
                    <GetLabel label="BDC" />
                  </span>{' '}
                  {item.rateformula}
                </>
              )}
            </Col>
            <Col span={2}>{item.tprole === 'OEM' ? 'NSC' : item.tprole}</Col>
            <Col span={2} className="pl-0 pr-0">
              <IBasket
                color="#DD7248"
                className="IBasket"
                onClick={() => {
                  setItem(item.key);
                  setSelectedItem(item);
                  setIsFeesSelected(true);
                  setFraisModalVisible(true);
                }}
              />
              <ModalSFS
                className="color-gray"
                width={560}
                trigger={({ setVisible }) => (
                  <IPen
                    className="IPen"
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                )}
                title="updateFrais"
              >
                <ProductFraisModal
                  feesList={feesList}
                  data={item}
                  setVisible={setVisible}
                  onSave={(item) => {
                    setFeesList((prevList: any[]) =>
                      prevList.some((p) => p.key === item.key)
                        ? prevList.map((p) => (p.key === item.key ? item : p))
                        : [...prevList, item]
                    );
                  }}
                  isCreate={false}
                />
              </ModalSFS>
            </Col>
          </Row>
        </Card>
      ))}

      <Row justify="center" align="middle">
        <ModalSFS
          trigger={({ setVisible }) => (
            <Button
              className="ut-reset-btn ut-btn-no-border no-box-shadow font-weight-500"
              onClick={() => setVisible(true)}
              icon={<PlusOutlined />}
            >
              <GetLabel label="addFee" />
            </Button>
          )}
          title="createFrais"
        >
          <ProductFeesModal
            isCreate
            feesList={feesList}
            durationmax={form.getFieldValue('durationmax')}
            setVisible={setVisible}
            onSave={(item) => {
              setFeesList([...feesList, item]);
            }} // Pass the addCard function
          />
        </ModalSFS>
        <ConfirmModal
          visible={FraismodalVisible}
          status="error"
          message="Êtes-vous sûr de vouloir supprimer le frais ? "
          onConfirm={() => {
            deleteCard(item);
            setFraisModalVisible(false);
          }}
          onCancel={() => !isInspect && setFraisModalVisible(false)}
          className="modalConfirmOrCancel"
        />
      </Row>
    </Form>
  );
};

export default ProductFees;
